import { cva } from 'class-variance-authority';

/**
 * Поля форм — README «Оверлеи → Поля форм»: высота 34, radius 16, border 1px line-field, 13 px;
 * фокус — border wine-bordeaux и кольцо 0 0 0 2px accent-wash; ошибка — кольцо status-error
 * (прототип: inset 0 0 0 1px status-error). Размер sm (30) — правка на месте в карточке (README §5).
 */
export const fieldVariants = cva(
  [
    'w-full min-w-0 rounded-16 border border-line-field bg-paper-pure font-ui text-ink-900',
    'placeholder:text-ink-400 outline-none focus-visible:outline-none',
    'transition-[border-color,box-shadow] duration-(--duration-fast) ease-(--ease-standard)',
    'focus:border-wine-bordeaux focus:shadow-focus-field',
    'disabled:cursor-not-allowed disabled:border-line-strong disabled:bg-surface-sunken disabled:text-ink-500',
    'aria-invalid:shadow-[inset_0_0_0_1px_var(--vw-status-error)] aria-invalid:focus:shadow-focus-field',
  ],
  {
    variants: {
      size: {
        md: 'h-34 px-10 text-[13px]',
        sm: 'h-30 px-10 text-[13px] font-medium',
      },
    },
    defaultVariants: { size: 'md' },
  },
);

export const textareaClasses = [
  // min-height 80 в прототипе — высота содержимого (content-box): + padding 8/8 + рамка 1/1 = 98 снаружи.
  'block w-full min-h-98 resize-none rounded-16 border border-line-field bg-paper-pure px-10 py-8',
  'font-ui text-[13px] leading-[20px] text-ink-900 placeholder:text-ink-400',
  'outline-none focus-visible:outline-none focus:border-wine-bordeaux focus:shadow-focus-field',
  'disabled:cursor-not-allowed disabled:bg-surface-sunken disabled:text-ink-500',
  'aria-invalid:shadow-[inset_0_0_0_1px_var(--vw-status-error)] aria-invalid:focus:shadow-focus-field',
].join(' ');

/** Выпадающая панель (multi, combo, select): README «Тени» — выпадающий список. */
export const dropdownPanelClasses =
  'z-50 overflow-hidden rounded-16 border border-line-strong bg-paper-pure shadow-dropdown animate-rise-menu';
